/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";

type Props = {
  children?: React.ReactNode;
};

const pageFooterStyle = css`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 32px;
  padding: 24px 24px 24px 24px;
  align-items: center;
`;

export const PageFooter = ({ children }: Props) => {
  return <div css={pageFooterStyle}>{children}</div>;
};
